export default __webpack_public_path__ + "static/media/imagePickAndPackContentOne.df82d8f2.png";